<div class="edit-block mat-elevation-z1">
    <h2>{{ data.data.exercice.exercice.name }}</h2>

    <mat-form-field color="primary">
      <mat-label>{{'seriePlaceholder' | translate}}</mat-label>
        <input matInput
               #repeatNumber
               [formControl]="nbRepeatFormControl"
               type="number"
               min="1"
               autocomplete="off">
        <mat-error *ngIf="nbRepeatFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
        <mat-error *ngIf="nbRepeatFormControl.hasError('min')">{{ 'Min_value' | translate: { value: repeatMinValue } }}</mat-error>
    </mat-form-field>

    <duration-control [(value)]="data.data.sessionItemExercice.duration"
                      [label]="'repetitionDurationPlaceholder' | translate"
                      [displayMode]="'hms'"
                      (change)="onDurationChange()">
    </duration-control>
    <duration-control [(value)]="data.data.sessionItemExercice.restTime"
                      [label]="'restTimePlaceholderAlt' | translate"
                      [displayMode]="'ms'"
                      (change)="onRestTimeChange()"
    >
    </duration-control>

    <div class="edit-totals">
        <div class="row">
            {{ 'totalTime' | translate }} : {{ baseComponent.totalDuration | durationVerbose:'seconds' }}
        </div>
    </div>

    <mat-form-field color="primary">
      <mat-label>{{'coachComment' | translate}}</mat-label>
        <textarea matInput
                  cdkTextareaAutosize
                  [(ngModel)]="data.data.sessionItemExercice.comment"
                  (ngModelChange)="onCommentChange()"></textarea>
    </mat-form-field>
</div>
